// globalConstants.js
export const S3URL = "https://jwlfyc-public-us-east-1.s3.amazonaws.com/";
export const MID_SEASON_MODE = false;
export const SHOW_MEDIA_SECTIONS = [
  { key: "press", label: "Press" },
  { key: "video", label: "Video" },
  { key: "audio", label: "Audio" },
  { key: "script", label: "Scripts" },
  { key: "images", label: "Images" },
  { key: "publications", label: "Publications" },
  { key: "design-presentations", label: "Design Presentations" },
];
export const BW_TITLE_TREATMENTS = [
  {
    slug: "marcello-hernandez-american-boy",
    image: "1773958480783-MarcelloHernandez-AB_TT_stacked-BW.png",
  },
  {
    slug: "this-is-a-gardening-show",
    image: "1774537514681-TIAGS_TT_BW.png",
  },
  {
    slug: "stranger-things",
    image: "1776463295451-ST5_TT_FinalSeason-white_v2.png",
  },
  {
    slug: "mating-season",
    image: "1774538872110-MatingSeason-S1_TT_light.png",
  },
  {
    slug: "pop-culture-jeopardy",
    image: "1783547892518-PCJeopardy_TT_stacked-white.png",
  },
];
